import axios from 'axios';
import BaseService from './baseService';

export default class ImportExportService extends BaseService {

  getFormations() {
    return this.axiosApiInstance.get(window.API_URL + '/api/importExport/Formations')
      .then(res => super.downloadFile(res.data, 'Export formation.csv'))
      .catch(err => super.handleHttpError(err));
  }

  getOffreEmplois() {
    return this.axiosApiInstance.get(window.API_URL + '/api/importExport/OffresEmploi')
      .then(res => super.downloadFile(res.data, 'Export offre emplois.csv'))
      .catch(err => super.handleHttpError(err));
  }

  importROME(currentUser,csvROME) {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + currentUser.token
      }
    };
    const formData = new FormData();
    formData.append('csvRomeCustom', new Blob([csvROME], { type: 'text/csv' }), csvROME.name);
    return axios.post(window.API_URL + '/api/importExport/ImportRomeCustom', formData, options)
      .then(res => res.data)
      .catch(err => super.handleHttpError(err));
  }

  getRebuildIndexFunnelMetier() {
    return this.axiosApiInstance.get(window.API_URL + '/api/importExport/RebuildFunnelMetierIndex')
      .then(res => res.data)
      .catch(err => super.handleHttpError(err));
  }

  importAppellationCompetence(currentUser,csvAC) {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + currentUser.token
      }
    };
    const formData = new FormData();
    formData.append('csvAC', new Blob([csvAC], { type: 'text/csv' }), csvAC.name);
    return axios.post(window.API_URL + '/api/importExport/ImportAppellationCompetence', formData, options)
      .then(res => res.data)
      .catch(err => super.handleHttpError(err));
  }

  importDuplicationFormation(currentUser,csvF) {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + currentUser.token
      }
    };
    const formData = new FormData();
    formData.append('csvF', new Blob([csvF], { type: 'text/csv' }), csvF.name);
    return axios.post(window.API_URL + '/api/importExport/ImportDuplicationFormation', formData, options)
    .then(res => super.downloadFile(res.data, 'ImportDuplicationResultat.csv'))
      .catch(err => super.handleHttpError(err));
  }

  //  Exporte toutes les formations en téléchargeant chaque page séparément.
  async exportFormationsCSVPaginated() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    
    if (!currentUser || !currentUser.token) {
      return Promise.reject(new Error('Non authentifié'));
    }

    // Instance Axios dédiée (sans intercepteur)
    const axiosExportInstance = axios.create();
    
    const headers = {
      'Authorization': `Bearer ${currentUser.token}`
    };

    try {
      // 1️. Télécharger la PREMIÈRE page pour connaître le nombre total
      const firstPageResponse = await axiosExportInstance.get(
        `${window.API_URL}/api/ImportExport/FormationsRecherche/Page/1`,
        { 
          headers, 
          responseType: 'blob', 
          timeout: 120000 // 2 minutes par page
        }
      );

      const totalPages = parseInt(firstPageResponse.headers['x-total-pages']);
      const totalFormations = parseInt(firstPageResponse.headers['x-total-formations']);

      // Télécharger la première page immédiatement
      const fileName1 = `formations_page_1_sur_${totalPages}.csv`;
      super.downloadFile(firstPageResponse.data, fileName1);

      // Notifier la progression initiale
      if (this.onProgress) {
        this.onProgress(1, totalPages, Math.round((1 / totalPages) * 100), totalFormations);
      }

      // 2️. Télécharger les pages restantes
      for (let page = 2; page <= totalPages; page++) {
        
        const response = await axiosExportInstance.get(
          `${window.API_URL}/api/ImportExport/FormationsRecherche/Page/${page}`,
          { headers, responseType: 'blob', timeout: 120000 }
        );
        
        // Télécharger immédiatement chaque page (utilise la méthode héritée)
        const fileName = `formations_page_${page}_sur_${totalPages}.csv`;
        super.downloadFile(response.data, fileName);
        
        // Notifier la progression
        const progress = Math.round((page / totalPages) * 100);
        
        if (this.onProgress) {
          this.onProgress(page, totalPages, progress, totalFormations);
        }

        // Petite pause pour ne pas surcharger le serveur
        await new Promise(resolve => setTimeout(resolve, 300));
      }

      return { success: true, totalFormations, totalPages };

    } catch (err) {
      super.handleHttpError(err);
      throw err;
    }
  }


  // Définit un callback pour suivre la progression de l'export.
  setProgressCallback(callback) {
    this.onProgress = callback;
  }

}
